import React from 'react';

import * as S from './styles';
import { DataFormProps } from 'types/InputsGridOfBannersProps';
import { listOptions } from './listOptions';

interface TypesGridBannersProps {
	dataForm: DataFormProps;
	setDataForm: React.Dispatch<React.SetStateAction<DataFormProps>>;
	isShow: boolean;
}

export default function TypesGridBanners({
	dataForm,
	setDataForm,
	isShow
}: TypesGridBannersProps) {
	return (
		<S.container $isShow={isShow}>
			<S.title>Escolha o modo de exibição do banner:</S.title>
			<S.list>
				{listOptions.length > 0 &&
					listOptions.map((item) => (
						<S.item
							key={item.type}
							$isSelected={item.type === dataForm.typeGridBanners}
							onClick={() => {
								setDataForm((obj) => ({ ...obj, typeGridBanners: item.type }));
							}}
						>
							<img src={item.image} alt={item.description} />
							<p>{item.name}</p>
						</S.item>
					))}
			</S.list>
		</S.container>
	);
}
